module.exports = __webpack_public_path__ + "static/media/2006.55e85a42.svg";